/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/qaCoverFromQDrive.ts
 * FILE_ID: JOBHUB-QA-COVER-QDRIVE-001
 * PURPOSE: Turn one QDrive id into a File for the QA cover upload.
 * WHY: The job page already has a client. The jobs-list download uses it.
 */
import type { JobHubHttpClient } from '../../jobHubDataAdapter'
import { quoteAttachMethods } from '../../../jobs-list/gateway/platformJobsQuoteAttach'

type AttachClient = Parameters<typeof quoteAttachMethods>[0]['apiClient']

export function coverFileFromQDrive(client: JobHubHttpClient, assetId: string, filename: string): Promise<File> {
  // Reused from: packages/job-hub/src/jobs-list/gateway/platformJobsQuoteAttach.ts (quoteAttachMethods qdrive.download)
  return quoteAttachMethods({
    // Same axios instance; only the declared header value type differs.
    apiClient: client as unknown as AttachClient,
    scope: {},
    createActionHeaders: () => ({}),
    outcome: () => Promise.resolve({ status: 'unsupported', reason: 'not used by qdrive.download' }),
  }).qdrive.download({ id: assetId, filename })
}
